import { DomainUpsertLoadingList } from "@/components/domain";
import { useSyncLoading } from "@/context/sheet";
import { useGetProvider, useUpdateProvider } from "@/hooks/providers";
import { CreateProvider, Provider } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(providers)/providers/_sheet/$id/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  const { isLoading, data: model } = useGetProvider(id);
  useSyncLoading(isLoading);

  if (isLoading || !model) return <DomainUpsertLoadingList />;
  return <Edit model={model} />;
}

function Edit({ model }: { model: Provider }) {
  const navigate = useNavigate();
  const { mutateAsync } = useUpdateProvider({
    onSuccess: (provider) => {
      navigate({
        to: "/providers",
        params: { id: provider.id.toString() },
      });
    },
  });

  const update = async (provider: CreateProvider) => {
    await mutateAsync({ id: model.id, ...provider });
  };
  return <Form model={model} onUpsert={update} />;
}
